import service from '../services/cashRegister.service';

export const cashRegister = {
    namespaced: true,
    state: {
        current: null,
        lastClose: null,
        history: [],
    },
    getters: {
        current: (state) => state.current,
        isOpen: (state) => !!(state.current && state.current.id),
        lastClose: (state) => state.lastClose,
        history: (state) => state.history,
    },
    actions: {
        async fetchCurrent({ commit }) {
            try {
                const response = await service.getCurrent();
                commit('SET_CURRENT', response.data);
            } catch {
                commit('SET_CURRENT', null);
            }
        },
        async fetchHistory({ commit }) {
            try {
                const response = await service.getHistory();
                commit('SET_HISTORY', response.data);
            } catch {
                commit('SET_HISTORY', []);
            }
        },
        async fetchLastClose({ commit }) {
            try {
                const response = await service.getLastClose();
                commit('SET_LAST_CLOSE', response.data);
            } catch {
                commit('SET_LAST_CLOSE', null);
            }
        },
        async open(context, data) {
            const response = await service.open(data);
            context.commit('SET_CURRENT', response.data);
            return response;
        },
        async close(context, data) {
            const response = await service.close(data);
            context.commit('SET_CURRENT', null);
            return response;
        },
    },
    mutations: {
        SET_CURRENT(state, session) {
            state.current = session;
        },
        SET_LAST_CLOSE(state, session) {
            state.lastClose = session;
        },
        SET_HISTORY(state, list) {
            state.history = list;
        },
    },
};
